export default {
      id: "wi-fi-usage",
      viewBox: "0 0 21 15",
      url: __webpack_public_path__ + "img/icons.svg#wi-fi",
      toString: function () {
        return this.url;
      }
    }